import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { initializeApp, deleteApp, getApps } from 'firebase/app';
import { getDatabase, ref, push } from 'firebase/database';

/* ── Firebase init (module-level, runs once) ── */
const firebaseConfig = {
  apiKey:            'AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc',
  authDomain:        'portfolio-e79b8-5854c.firebaseapp.com',
  projectId:         'portfolio-e79b8-5854c',
  storageBucket:     'portfolio-e79b8-5854c.firebasestorage.app',
  messagingSenderId: '694813500771',
  appId:             '1:694813500771:web:199c8f7e7795e560205f56',
  measurementId:     'G-SBRW34PBBE',
  databaseURL:       'https://portfolio-e79b8-5854c-default-rtdb.firebaseio.com',
};
const APP_NAME = 'portfolio-contact';
let db;
try {
  const existing = getApps().find(a => a.name === APP_NAME);
  if (existing) deleteApp(existing);
  const app = initializeApp(firebaseConfig, APP_NAME);
  db = getDatabase(app);
  console.log('[Firebase] ✅ Ready');
} catch (e) {
  console.error('[Firebase] ❌ Init failed:', e);
}

export default function Contact({ loaded, isMobile }) {
  const contactRef = useRef(null);
  const [form,     setForm]     = useState({ name: '', email: '', message: '' });
  const [status,   setStatus]   = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!loaded) return;
    const ctx = gsap.context(() => {
      gsap.timeline({
        scrollTrigger: { trigger: contactRef.current, start: 'top 75%', end: 'top 20%', scrub: 1 }
      })
        .fromTo('.ct-big-text', { y: 100, opacity: 0, skewY: 4 }, { y: 0, opacity: 1, skewY: 0, duration: 1, ease: 'power3.out' })
        .fromTo('.ct-left',     { x: -60, opacity: 0 }, { x: 0, opacity: 1, duration: 0.7 }, '-=0.5')
        .fromTo('.ct-right',    { x: 60,  opacity: 0 }, { x: 0, opacity: 1, duration: 0.7 }, '<');
    }, contactRef);
    return () => ctx.revert();
  }, [loaded]);
  // Replace your handleSubmit function in Contact.jsx with this:

const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorMsg('');

  if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
    setErrorMsg('Please fill in all fields.');
    return;
  }

  setStatus('sending');

  try {
    // ── Step 1: Save to Firebase (keep your existing logic) ──
    if (db) {
      await push(ref(db, 'formSubmissions'), {
        name:      form.name.trim(),
        email:     form.email.trim(),
        message:   form.message.trim(),
        timestamp: new Date().toISOString(),
      });
      console.log('[Contact] ✅ Saved to Firebase');
    }

    // ── Step 2: Send emails via your Express backend ──
    const res = await fetch('https://modern-backend-isn7.onrender.com/api/contact', {
      // Change to your deployed backend URL in production
      // e.g. 'https://your-backend.onrender.com/api/contact'
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name:    form.name.trim(),
        email:   form.email.trim(),
        message: form.message.trim(),
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || 'Email sending failed.');
    }

    console.log('[Contact] ✅ Emails sent!');
    setStatus('done');
    setForm({ name: '', email: '', message: '' });

  } catch (err) {
    console.error('[Contact] ❌ Error:', err.message);
    setErrorMsg(err.message);
    setStatus('idle');
  }
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setErrorMsg('');
  //   if (!form.name.trim() || !form.email.trim() || !form.message.trim()) { setErrorMsg('Please fill in all fields.'); return; }
  //   if (!db) { setErrorMsg('Firebase not initialised. Check console.'); return; }
  //   setStatus('sending');
  //   try {
  //     const newRef = await push(ref(db, 'formSubmissions'), { name: form.name.trim(), email: form.email.trim(), message: form.message.trim(), timestamp: new Date().toISOString() });
  //     console.log('[Contact] ✅ Saved! Key:', newRef.key);
  //     setStatus('done');
  //     setForm({ name: '', email: '', message: '' });
  //   } catch (err) {
  //     console.error('[Contact] ❌ Failed:', err.code, err.message);
  //     setErrorMsg(err.message?.toLowerCase().includes('permission') ? 'Permission denied — set ".write": true in Firebase Rules.' : err.message);
  //     setStatus('idle');
  //   }
  // };

  const inputStyle = { width: '100%', background: 'var(--black)', border: '1px solid var(--border)', padding: '0.85rem 1rem', color: 'var(--white)', fontFamily: 'Syne', fontSize: '0.9rem', outline: 'none', transition: 'border-color 0.3s', boxSizing: 'border-box', cursor: 'none' };
  const labelStyle = { fontFamily: 'Space Mono', fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', display: 'block', marginBottom: '0.5rem' };

  return (
    <section id="contact" ref={contactRef} style={{ minHeight: '100vh', background: 'var(--black)', padding: isMobile ? '5rem 5vw' : '8rem 5vw', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', bottom: '-20%', right: '-5%', width: 700, height: 700,  borderRadius: '50%', pointerEvents: 'none' }} />
      <div style={{  margin: '0 auto' }}>
        <div style={{ fontFamily: 'Space Mono', fontSize: '0.7rem', color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: '1.5rem', opacity: 0.8 }}>06 — Contact</div>
        <div style={{ overflow: 'hidden', marginBottom: isMobile ? '3rem' : '5rem' }}>
          <div className="ct-big-text" style={{ fontFamily: 'Syne', fontSize: 'clamp(1.6rem,3vw,3rem)', fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 0.92 }}>
            Let's Build<br /><span style={{ color: 'var(--acid)' }}>Something</span>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '3rem' : '5rem' }}>
          {/* LEFT */}
          <div className="ct-left">
            <p style={{ fontFamily: 'Syne', fontSize: '1.05rem', color: 'var(--white)', lineHeight: 1.75, marginBottom: '3rem', maxWidth: 400 }}>
              Open to full-time roles, freelance projects, and startup collaborations. I build things that scale.
            </p>
{[
  { l: 'Email',    v: 'naveenkarnan5@gmail.com',  c: 'var(--acid)', href: 'mailto:naveenkarnan5@gmail.com'           },
  { l: 'Phone',    v: '+91 7548865624',            c: 'var(--acid)', href: 'tel:+917548865624'                        },
  { l: 'Location', v: 'Chennai, India',            c: 'var(--acid)', href: 'https://maps.google.com/?q=Chennai,India' },
  // { l: 'Status',   v: 'Available Now',             c: '#ff6b6b',     href: null },
].map((item, i) => (
  <div key={i} style={{ marginBottom: '1.5rem' }}>
    <div style={{ fontFamily: 'Space Mono', fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '0.3rem' }}>{item.l}</div>
    {item.href ? (
      <a
      
        href={item.href}
        target={item.l === 'Location' ? '_blank' : undefined}
        rel={item.l === 'Location' ? 'noopener noreferrer' : undefined}
        style={{ fontFamily: 'Syne', fontSize: '1rem', fontWeight: 600, color: item.c, textDecoration: 'none', cursor: 'none', transition: 'opacity 0.2s', display: 'inline-block' }}
        onMouseEnter={e => e.currentTarget.style.opacity = '0.75'}
        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
      >{item.v}</a>
    ) : (
      <div style={{ fontFamily: 'Syne', fontSize: '1rem', fontWeight: 600, color: item.c }}>{item.v}</div>
    )}
  </div>
))}            <div style={{ marginTop: '2.5rem', display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              {[
                { label: 'GitHub',    href: 'https://github.com/Naveenak27' },
                { label: 'LinkedIn',  href: 'https://www.linkedin.com/in/naveen-karnan-4987811a5' },
                { label: 'Instagram', href: 'https://instagram.com/_._naveenak_._' },
                { label: 'WhatsApp',  href: 'https://api.whatsapp.com/send?phone=7548865624' },
              ].map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noopener noreferrer"
                  style={{ fontFamily: 'Space Mono', fontSize: '0.6rem', padding: '0.55rem 1rem', border: '1px solid var(--border)', color: 'white', letterSpacing: '0.08em', textDecoration: 'none', transition: 'all 0.3s', display: 'inline-block' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--acid)'; e.currentTarget.style.color = 'var(--acid)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = '#1a1a1a'; e.currentTarget.style.color = 'white'; }}
                >{s.label}</a>
              ))}
            </div>
          </div>

          {/* RIGHT — Form */}
          <div className="ct-right">
            {status === 'done' ? (
              <div style={{ height: '100%', minHeight: 300, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', border: '1px solid rgba(200,240,74,0.15)', padding: '3rem' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✓</div>
                <div style={{ fontFamily: 'Syne', fontSize: '1.4rem', fontWeight: 800, color: 'var(--acid)', marginBottom: '0.75rem' }}>Message Sent!</div>
                <div style={{ fontFamily: 'Space Mono', fontSize: '0.7rem', color: 'white', marginBottom: '2rem' }}>I'll reply within 24 hours.</div>
                <button onClick={() => setStatus('idle')}
                  style={{ background: 'transparent', border: '1px solid var(--muted)', color: 'white', fontFamily: 'Space Mono', fontSize: '0.6rem', padding: '0.6rem 1.5rem', letterSpacing: '0.1em', cursor: 'pointer', transition: 'all 0.3s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--acid)'; e.currentTarget.style.color = 'var(--acid)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--muted)'; e.currentTarget.style.color = 'white'; }}
                >Send Another</button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {errorMsg && (
                  <div style={{ background: '#1a0000', border: '1px solid #ff4444', padding: '0.8rem 1rem', fontFamily: 'Space Mono', fontSize: '0.62rem', color: '#ff6b6b', lineHeight: 1.6 }}>{errorMsg}</div>
                )}
                <div>
                  <label style={labelStyle}>Your Name</label>
                  <input type="text" value={form.name} required onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your Name" style={inputStyle}
                    onFocus={e => e.target.style.borderColor = 'var(--acid)'} onBlur={e => e.target.style.borderColor = 'var(--muted)'} />
                </div>
                <div>
                  <label style={labelStyle}>Email Address</label>
                  <input type="email" value={form.email} required onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Your Email" style={inputStyle}
                    onFocus={e => e.target.style.borderColor = 'var(--acid)'} onBlur={e => e.target.style.borderColor = 'var(--muted)'} />
                </div>
                <div>
                  <label style={labelStyle}>Message</label>
                  <textarea value={form.message} rows={5} required onChange={e => setForm({ ...form, message: e.target.value })} placeholder="How can I help you?" style={{ ...inputStyle, resize: 'none' }}
                    onFocus={e => e.target.style.borderColor = 'var(--acid)'} onBlur={e => e.target.style.borderColor = 'var(--muted)'} />
                </div>
                <button type="submit" disabled={status === 'sending'} onClick={handleSubmit}
                  style={{ background: status === 'sending' ? 'white' : 'var(--acid)', color: 'var(--black)', fontFamily: 'Syne', fontWeight: 700, fontSize: '0.88rem', padding: '1rem 2.5rem', letterSpacing: '0.06em', textTransform: 'uppercase', alignSelf: 'flex-start', border: `2px solid ${status === 'sending' ? 'white' : 'var(--acid)'}`, transition: 'all 0.3s', cursor: status === 'sending' ? 'wait' : 'none' }}
                  onMouseEnter={e => { if (status !== 'sending') { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--acid)'; } }}
                  onMouseLeave={e => { if (status !== 'sending') { e.currentTarget.style.background = 'var(--acid)'; e.currentTarget.style.color = 'var(--black)'; } }}
                >{status === 'sending' ? 'Sending…' : 'Send Message →'}</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
